import {createPageableParams} from "@/modules/core/services/table-utils";
import WrapperService from "@/modules/core/services/wrapper-service";

const sortUsersRoleInvitationFields = ["facilityName", "roleName"]
const sortUsersRoleInvitationDatabaseFields = ["f.name", "wr.name"]

const sortCustomerRoleInvitationFields = ["facilityName", "roleName", "userName", "userEmail"]
const sortCustomerRoleInvitationDatabaseFields = ["f.name", "wr.name", "u.name", "u.email"]

const sortCustomerProcessInvitationFields = ["facilityName", "processName", "endDate", "assignedToName", "assignedToMail"]
const sortCustomerProcessInvitationDatabaseFields = ["f.name", "p.name", "date", "u.name", "u.email"]

const sortPersonalOpenSignaturesFields = ["facilityName", "translatedDocuType", "formattedDate"]
const sortPersonalOpenSignaturesDatabaseFields = ["f.name", "", "createdAt"]

const sortCustomerOpenSignaturesFields = ["facilityName", "translatedDocuType", "formattedDate", "assignedToName"]
const sortCustomerOpenSignaturesDatabaseFields = ["f.name", "", "createdAt", "assignedTo.name"]

const API_URL_DASHBOARD = process.env.VUE_APP_ROOT_API + "/api/v1/dashboard"
const API_URL_NOTIFICATION = process.env.VUE_APP_ROOT_API + "/api/v1/notification"

const serviceName = "DashboardHome-Service: ";
export default class DashboardHomeService {

  static async countBuildings(successF, errorF) {
    await WrapperService.get(API_URL_DASHBOARD + "/count/building", null, serviceName, successF, errorF);
  }

  static async countFacilities(successF, errorF) {
    await WrapperService.get(API_URL_DASHBOARD + "/count/facility", null, serviceName, successF, errorF);
  }

  static async countProcessesUpcoming(successF, errorF) {
    await WrapperService.get(API_URL_DASHBOARD + "/count/process/upcoming", null, serviceName, successF, errorF);
  }

  static async countProcessesFinished(successF, errorF) {
    await WrapperService.get(API_URL_DASHBOARD + "/count/process/finished", null, serviceName, successF, errorF);
  }

  static async readNotificationDashboard(successF, errorF) {
    await WrapperService.get(API_URL_NOTIFICATION + "/dashboard", null, serviceName, successF, errorF);
  }

  static async readAllPageableUsersRoleInvitations(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortUsersRoleInvitationFields, sortUsersRoleInvitationDatabaseFields);
    await WrapperService.get(API_URL_DASHBOARD + "/role/invitation", { params: params }, serviceName, successF, errorF)
  }

  static async readAllPageableUserInvitations(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, [], []);
    await WrapperService.get(API_URL_DASHBOARD + "/user/invitation", { params: params}, serviceName, successF, errorF);
  }

  static async readCustomerProcessInvitations(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortCustomerProcessInvitationFields, sortCustomerProcessInvitationDatabaseFields);
    await WrapperService.get(API_URL_DASHBOARD + "/customer/process/invitation", { params: params}, serviceName, successF, errorF);
  }

  static async readFacilityAssignedProcessInvitations(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortCustomerProcessInvitationFields, sortCustomerProcessInvitationDatabaseFields);
    await WrapperService.get(API_URL_DASHBOARD + "/process/invitation/assigned-facilities", { params: params}, serviceName, successF, errorF);
  }

  static async readCustomerRoleInvitations(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortCustomerRoleInvitationFields, sortCustomerRoleInvitationDatabaseFields);
    await WrapperService.get(API_URL_DASHBOARD + "/customer/role/invitation", { params: params}, serviceName, successF, errorF);
  }

  static async readFacilityAssignedRoleInvitations(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortCustomerRoleInvitationFields, sortCustomerRoleInvitationDatabaseFields);
    await WrapperService.get(API_URL_DASHBOARD + "/role/invitation/assigned-facilities", { params: params}, serviceName, successF, errorF);
  }

  static async readAllPageableSignatures(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortPersonalOpenSignaturesFields, sortPersonalOpenSignaturesDatabaseFields);
    await WrapperService.get(API_URL_DASHBOARD + "/signatures/open", {params: params }, serviceName, successF, errorF);
  }

  static async readAllPageableSignaturesByCustomer(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortCustomerOpenSignaturesFields, sortCustomerOpenSignaturesDatabaseFields);
    await WrapperService.get(API_URL_DASHBOARD + "/customer/signatures/open", {params: params }, serviceName, successF, errorF);
  }

  static async readAllPageableSignaturesByAssignedFacility(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortCustomerOpenSignaturesFields, sortCustomerOpenSignaturesDatabaseFields);
    await WrapperService.get(API_URL_DASHBOARD + "/signatures/open/assigned-facilities", {params: params }, serviceName, successF, errorF);
  }
}
